import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignInPageRoutingModule } from './signin-routing.module';
import { SignInPageComponent } from './signin.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [SignInPageComponent],
  imports: [
    CommonModule,
    SignInPageRoutingModule,
    SharedModule
  ]
})
export class SignInPageModule { }
